export enum TemporaryAccessType {
  Location = 'Location',
  User = 'User',
}
